import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

// Connects to data-controller="collapse"
export default class extends Controller {
  static targets = ["span", "clinicHistory", "buttons", "frame", "frameContainer"];
  static values = {
    registro: Number,
    collapseClass: String
  }

  connect() {
    this.collapsed = false
  }

  toggle(event) {
    this.buttonsTarget.style.width = "8%"
    this.frameContainerTarget.style.width = "70%";

    this.spans().forEach(span => {
      span.style.display = 'none';
    });

    this.links().forEach(link => {
      link.style.width = 'fit-content';
    });

    this.collapsed = true
  }

  buttonClick(event) {
    if (this.collapsed) {
      event.preventDefault()
      this.buttonsTarget.style.width = "max-content"

      this.frameTarget.src = null
      this.frameTarget.innerHTML = ''
      this.frameTarget.reload()
    }
    this.collapsed = false

    if (this.collapsed == false) {
      this.frameContainerTarget.style.removeProperty('width')

      this.spans().forEach(span => {
        span.style.display = 'flex';
      });

      this.links().forEach(link => {
        link.style.width = '200px';
      });
    }
  }

  spans() {
    return this.buttonsTarget.querySelectorAll('span')
  }

  links() {
    return this.buttonsTarget.querySelectorAll('a.btn')
  }
}
